// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Oks3tx3ULnpIWD {
  padding: var(--ds-space-200, 16px);
  border-radius: var(--ds-radius-small, 3px);
  background-color: var(--ds-background-danger, #ffedeb);
}
.Oks3tx3ULnpIWD .yiGxALq27NzVkB {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  gap: var(--ds-space-200, 16px);
}
.Oks3tx3ULnpIWD p {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
}
.Oks3tx3ULnpIWD a {
  font-weight: var(--ds-font-weight-medium, 500);
}
`, ""]);
// Exports
export var chunkLoadErrorMessage = `Oks3tx3ULnpIWD`;
export var row = `yiGxALq27NzVkB`;
export default ___CSS_LOADER_EXPORT___;
